import angular from 'angular';
import 'babel-polyfill';
import 'oclazyload';
import Raven from 'raven-js';
import ngRaven from 'raven-js/plugins/angular';
import uiRouter from 'angular-ui-router';
import uiMask from 'angular-ui-mask';
import LocalStorageModule from 'angular-local-storage';
import GoogleAnalyticsModule from 'angular-google-analytics';
import toaster from 'angularjs-toaster';
import ngAnimate from 'angular-animate';
import ngMessages from 'angular-messages';

import { UiKit } from '@toasttab/ui-kit';
import envFromHost from '@toasttab/env-from-hostname';
import { Geolocation } from '@toasttab/geolocation';
import { CustomerAuthentication } from '@toasttab/customer-authentication';
import { OnlineOrderingUiKit } from '@toasttab/oo-ui-kit';

import '@toasttab/geolocation/dist/styles.css';
import '@toasttab/ui-kit/dist/styles.css';
import '@toasttab/oo-ui-kit/dist/styles.css';
import '@toasttab/customer-authentication/dist/styles.css';
import 'animate.css';
import 'angularjs-toaster/toaster.min.css';
import './sass/checkout.scss';
import './sass/main.scss';

import './templates/checkout/checkoutSteps/checkoutCustomerTable.html';

import './templates/checkout/summary/readOnlyShoppingCart.html';
import './templates/checkout/summary/readOnlyShoppingCartOptions.html';
import './templates/checkout/summary/readOnlyShoppingCartModifierGroups.html';

import './templates/order/menu/menuGroup.html';

import './templates/order/modifiers/modifierDialog.html';
import './templates/order/modifiers/modifierGroups.html';
import './templates/order/modifiers/optionsSingleSelect.html';
import './templates/order/modifiers/optionsMultiSelect.html';
import './templates/order/modifiers/subModifierGroups.html';
import './templates/order/modifiers/subOptionsSingleSelect.html';
import './templates/order/modifiers/subOptionsMultiSelect.html';

import './templates/order/summary/orderSummaryDetails.html';
import './templates/order/summary/orderSummaryEditDetails.html';
import './templates/order/summary/shoppingCart.html';
import './templates/order/summary/shoppingCartModifierGroups.html';
import './templates/order/summary/shoppingCartOptions.html';

import { ABTestingModule } from './javascript/ab_testing/ab_testing.module';
import { AccountModule } from './javascript/account/account.module';
import { CheckoutModule } from './javascript/checkout/checkout.module';
import { CommonModule } from './javascript/common/common.module';
import { OrderModule } from './javascript/order/order.module';
import { LandingModule } from './javascript/landing/landing.module';

import { AppConfig } from './javascript/config';
import { HttpRequestInterceptor } from './javascript/httpRequestInterceptor';

/* eslint-env browser */
const sentryDsn = 'none' === process.env.NODE_ENV // eslint-disable-line no-undef, no-process-env
    ? null // Don't send to sentry when running unit tests
    : 'https://2879b132b4dc44cb8dd8f0385559b47b@app.getsentry.com/92331';
const release = process.env.PKG_VERSION; // eslint-disable-line no-undef, no-process-env
const environment = envFromHost(window.location.hostname);

Raven
    .config(sentryDsn, {
        whitelistUrls: [
            /\.toasttab\.com\//,
        ],
        release,
        environment
    })
    .addPlugin(ngRaven)
    .install();

export const AppModule = angular.module('oo', [
    /* Our modules */
    OnlineOrderingUiKit,
    UiKit,
    CustomerAuthentication,
    Geolocation,
    CheckoutModule,
    AccountModule,
    CommonModule,
    OrderModule,
    LandingModule,
    ABTestingModule,

    /* Third-Party Modules */
    'ngRaven',
    'oc.lazyLoad',
    uiMask,
    uiRouter,
    LocalStorageModule,
    GoogleAnalyticsModule,
    toaster,
    ngAnimate,
    ngMessages
])
    .constant('ORDER_TYPES', {
        TAKE_OUT: 'TAKE_OUT',
        DELIVERY: 'DELIVERY'
    })
    .constant('FULFILLMENT_TYPES', {
        ASAP: 'ASAP',
        FUTURE: 'FUTURE'
    })
    .constant('CALENDAR_STRINGS', {
        sameDay: '[Today] M/D',
        nextDay: '[Tomorrow] M/D',
        nextWeek: 'ddd M/D',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'ddd M/D'
    })
    .config(AppConfig)
    .run(function($rootScope, $location, $window) {
        'ngInject';
        let locationSearch;

        if ($window.Appcues) {
            $window.Appcues.anonymous();
        }

        $rootScope.$on('$stateChangeStart', function() {
            //save location.search so we can add it back after transition is done
            locationSearch = $location.search();
        });

        $rootScope.$on('$stateChangeSuccess', function() {
            //restore all query string parameters back to $location.search
            $location.search(locationSearch);
        });

        $rootScope.$on('$locationChangeSuccess', function() {
            if ($window.Appcues) {
                $window.Appcues.page();
            }
        });

    })
    .factory('httpRequestInterceptor', HttpRequestInterceptor)
    .name;
